<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="items" :rowCount="25" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
export default {
  components: {
    TablePage,
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Abbreviation", value: "abbreviation" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [
        {
          title: "Facility 1",
          abbreviation: "F1",
          description: "facility 1 description",
        },
        {
          title: "Facility 2",
          abbreviation: "F2",
          description: "facility 2 description",
        },
        {
          title: "Facility 3",
          abbreviation: "F3",
          description: "facility 3 description",
        },
      ],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>